/**
 * @param {string} date
 * @returns {Date}
 */
export default function formatDateForSaving(date) {
	return new Date(date.replace(/-/g, '/').replace(/T.+/, ''));
}
